module.exports = __webpack_public_path__ + "img/transport_FerryBooking.bb2c980.png";